import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {updateUserProfileAction, updateUserVideoAvatarAction} from 'redux/auth/authAsyncActions';
import {IStore} from 'redux/interface';
import {IVideoAvatar} from 'redux/auth/interfaces';
import Loader from 'components/loader';
import BotIcon from 'assets/image/user-settings/BotDefaultAvatar.svg';
import {authAsyncActions, getVideoAvatars} from '../../redux/pageAsyncActions';
import {VideoAvatarDetails} from '../video-avatar-details/VideoAvatarDetails';
import {FormattedMessage} from 'react-intl';

import './styles.scss';

interface IVideoAvatarListProps {
  closeModal: () => void;
}

export const VideoAvatarList = ({
  closeModal
}: IVideoAvatarListProps): JSX.Element => {
  const {videoAvatars, userProfile} = useSelector((state: IStore) => state.auth);
  const {loading} = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();

  const avatarList: IVideoAvatar[] = videoAvatars?.filter(item => item.fileUrl) ?? [];

  useEffect(() => {
    dispatch(authAsyncActions[getVideoAvatars]());
  }, []);

  function handleSelectAvatar(avatar: IVideoAvatar) {
    if (userProfile) {
      dispatch(updateUserProfileAction({...userProfile, dialogAvatarId: avatar.imageId}));
      dispatch(updateUserVideoAvatarAction(avatar.id));
    }
    closeModal();
  }

  function renderModalBody() {
    if (loading.includes(getVideoAvatars)) {
      return <Loader nested />;
    }

    if (!avatarList.length) {
      return (
        <p className="video-avatar-list__empty" role="status">
          <FormattedMessage
            id="gritx.user-settings.noAvatars"
            defaultMessage="No avatars available."
          />
        </p>
      );
    }

    return (
      <div className="video-avatar-list__grid"
        aria-label="Select avatar">
        {avatarList.map((item, index) => (
          <VideoAvatarDetails
            key={item.id}
            avatar={item}
            isSelected={item.imageId === userProfile?.dialogAvatarId}
            onSelect={() => handleSelectAvatar(item)}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="video-avatar-list__modal-content">
      <div className="video-avatar-list__modal-title">
        <FormattedMessage
          id="gritx.user-settings.chooseAvatar"
          defaultMessage="Choose Avatar"
        />
      </div>
      {renderModalBody()}
    </div>
  );
};
